import React from 'react'
import exact from 'prop-types-exact'
import * as Types from 'types'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { AVAILABLE_STATUSES, ProductType } from 'config/products'
import { getProductConfig } from 'utils'
import { startsWith } from 'lodash'
import { ExternalLink } from 'components'
import { isTaxableCustodialAccountsEnabled } from 'config/portal'

const propTypes = {
  subscribedProducts: PropTypes.arrayOf(Types.subscribedProduct).isRequired,
  headingAs: PropTypes.oneOf(['h1', 'h2']),
}

const defaultProps = {
  headingAs: 'h2',
}

const isAvailable = (product) => {
  return AVAILABLE_STATUSES.includes(product.status)
}
const isInternal = (link) => {
  return startsWith(link, '/')
}
const ProductAffordance = ({ link, product, isFirst }) => {
  const buttonClass =
    'button-primary-outline' + (isFirst ? ' first-open-button' : '')
  if (isAvailable(product)) {
    if (isInternal(link)) {
      return (
        <Link to={link} className={buttonClass}>
          Open
        </Link>
      )
    }
    return (
      <ExternalLink link={link} className={buttonClass}>
        Open
      </ExternalLink>
    )
  }
  return (
    <span>
      Pending Authorization
      {product.signerName && ` by ${product.signerName}`}
    </span>
  )
}
ProductAffordance.propTypes = {
  link: PropTypes.string.isRequired,
  product: Types.subscribedProduct.isRequired,
  isFirst: PropTypes.bool.isRequired,
}
/* eslint-disable react/prop-types */
//False positive: props are defined above and assigned via exact() below, but the eslint doesn't fully recognize that pattern
function ProductPortal({ subscribedProducts, headingAs: HeadingComp }) {
  if (!subscribedProducts.length) {
    return (
      <div className="product-portal">
        <p>You currently have no subscribed products</p>
      </div>
    )
  }
  return (
    <div className="product-portal">
      <HeadingComp>Your subscribed product(s)</HeadingComp>
      {subscribedProducts.map((product, index) => {
        const {
          icon: Icon,
          productLink,
          description,
          descriptionList,
          descriptionHeader,
          cardTitle,
          useDetailedLayout,
        } = getProductConfig(product.type)
        if (!Icon) {
          // eslint-disable-next-line
          console.error(`No config found for: ${product.type}`)
          return null
        }
        const isAutomaticRollovers =
          product.type === ProductType.AUTOMATIC_ROLLOVERS
        const isCustodialAccounts =
          product.type === ProductType.TAXABLE_ACCOUNTS &&
          isTaxableCustodialAccountsEnabled()
        return (
          <div key={product.type} className="product-portal-container">
            <div className="product-portal-header">
              {useDetailedLayout ? (
                <>
                  <div className="product-icon-large">
                    <Icon width="47" height="47" aria-hidden="true" />
                  </div>
                  <div className="product-info">
                    <ProductAffordance
                      link={productLink}
                      product={product}
                      isFirst={index === 0}
                    />
                    <p className="product-type">{cardTitle || product.type}</p>
                    {!!descriptionHeader && (
                      <p className="product-heading">
                        <strong>{descriptionHeader}</strong>
                      </p>
                    )}
                    {isCustodialAccounts && !!description && (
                      <p className="product-description">{description}</p>
                    )}
                    {!!descriptionList.length && (
                      <ul className="product-list">
                        {isAutomaticRollovers ? (
                          <>
                            <li className="desc-li">
                              {descriptionList[0]}
                              <ul className="product-list">
                                <li className="desc-li">
                                  {descriptionList[1]}
                                </li>
                                <li className="desc-li">
                                  {descriptionList[2]}
                                </li>
                              </ul>
                            </li>
                            <li className="desc-li">{descriptionList[3]}</li>
                          </>
                        ) : (
                          descriptionList.map((item) => (
                            <li key={item} className="desc-li">
                              {item}
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                    {!isCustodialAccounts && !!description && (
                      <p className="product-description">{description}</p>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="product-icon-small">
                    <Icon width="47" height="47" aria-hidden="true" />
                  </div>
                  <div className="product-info">
                    <ProductAffordance
                      link={productLink}
                      product={product}
                      isFirst={index === 0}
                    />
                    <p className="product-type">{cardTitle || product.type}</p>
                    <p className="product-description">{description}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

ProductPortal.propTypes = exact(propTypes)
ProductPortal.defaultProps = defaultProps

export default React.memo(ProductPortal)
